/**
 * PdfPreviewPanel — the rendered half of usePdfPreview, shared by the report
 * pages so their previews cannot drift in wording or behaviour.
 *
 * The iframe's `title` is its accessible name and the only thing a screen
 * reader gets from the preview; Download PDF is the real affordance. No gate
 * catches a missing title — jsx-a11y/iframe-has-title is a warning in
 * eslint-config-react-app and CI runs eslint with no --max-warnings.
 */
import React from 'react';

const cardStyle = {
  padding: '1.25rem',
  background: 'var(--ui-surface)',
  border: '1px solid var(--ui-border)',
  borderRadius: '12px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  marginTop: '1rem',
};

const PdfPreviewPanel = ({ preview, isMobile, title }) => {
  if (!preview) return null;

  return (
    <div style={cardStyle}>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.75rem',
          marginBottom: '0.75rem',
        }}
      >
        {/* Labelled with the inputs it was built from, so a preview left
            standing beside changed controls cannot be mistaken for them. */}
        <span style={{ fontSize: '0.8125rem', fontWeight: 600, color: 'var(--ui-text-secondary)' }}>
          Preview — {preview.caption}
        </span>
        <button
          type="button"
          onClick={() => preview.doc.save(preview.fileName)}
          style={{
            padding: '0.5rem 1rem',
            background: 'var(--ui-surface)',
            color: 'var(--ui-primary)',
            border: '1px solid var(--ui-primary)',
            borderRadius: '8px',
            fontWeight: 600,
            fontSize: '0.8125rem',
            cursor: 'pointer',
            fontFamily: 'var(--font-family-primary)',
          }}
        >
          Download PDF
        </button>
      </div>

      {isMobile ? (
        <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--ui-text-secondary)' }}>
          The preview needs a larger screen. Use Download PDF to get the file.
        </p>
      ) : (
        <iframe
          title={title}
          src={preview.url}
          style={{
            width: '100%',
            height: '75vh',
            border: '1px solid var(--ui-border)',
            borderRadius: '8px',
            background: 'var(--ui-surface-recessed)',
          }}
        />
      )}
    </div>
  );
};

export default PdfPreviewPanel;
